<template>
<div>
		<ssg-messagebox titles='验证邮箱' width="500px" v-if="maskshow && masktype=='veremail'" subname="我知道了" :shutshow="false"
		 height="auto" @sub="subSendEmail">
				<div class="tent">
                 <img src="../../assets/img/1_06.png" alt="">  
				<p class="prompt">我们给您的邮箱
					<a>{{baseInfo.email }}</a>发送了一封验证邮件，请按照验证邮件里的提示在<span>24小时内</span>激活您的账号
				</p>
			</div>
		</ssg-messagebox>
		<ssg-messagebox titles='绑定邮箱' width="500px" v-if="maskshow && masktype=='bindemail'" height="auto" @sub="subEmail">
			<div class="tent">
             <img src="../../assets/img/1_06.png" alt="">	
			<div class="form">
				<el-form ref="baseInfos" label-width="0" :rules="rules" :model="baseInfos" label-position="right">
					<el-form-item  prop="bindemail" style="margin-bottom: 10px">
						<el-input v-model="baseInfos.bindemail" placeholder="请输入您要绑定的邮箱地址"></el-input>
					</el-form-item>
				</el-form>
				<p class="prompt">
					我们将会给您的邮箱发送一封验证邮件，请按照验证邮件里的提示在24小时内激活您的账号。
				</p>
			</div>
			</div>		
		</ssg-messagebox>
		<ssg-messagebox titles='更换手机号' v-if="maskshow && masktype=='replace'" height="auto" width="570px" @sub="vsub">
			<div class="form">
				<el-form label-width="100px" ref="changeInfo" :rules="changerules" :model="changeInfo" label-position="right">
					<el-form-item label="手机号">
						<el-input v-model="changeInfo.phoneNumber" disabled></el-input>
					</el-form-item>
					<el-form-item label="登陆密码" prop="password">
						<el-input v-model="changeInfo.password" type="password"></el-input>
					</el-form-item>
					<el-form-item label="新手机号" prop="mobile">
						<el-input v-model="changeInfo.mobile" maxlength="11"></el-input>
						<p class="prompt pad10"><span>提示：更换后，下次需要使用新的手机号来登录</span></p>
					</el-form-item>
					<el-form-item label="图形验证码" prop="picvert" style="width:375px">
						<el-input v-model="changeInfo.picvert" maxlength="4"></el-input>
						<div class="mobilecert">
							<img class="imgcert" :src="validcodeurl" />
							<div :class="switchstatus == false ? 'switchbtn' : 'switchbtn switchbtn_click'" @click="onswitch"></div>
						</div>
					</el-form-item>
					<el-form-item label="手机验证码" prop="validcode" style="width:375px">
						<el-input v-model="changeInfo.validcode"></el-input>
						<button class="btn subbtn mobilecert" type="button" v-if="!timeshow" @click="realSendSms">获取验证码</button>
						<button  type="button" class="nosmsbtn" v-if="timeshow" disabled>
							{{count}} 重新发送
						</button>
					</el-form-item>
				</el-form>
			</div>
		</ssg-messagebox>
		<!-- vueCropper 剪裁图片实现-->
		<el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
			<div class="cropper-content">
				<div class="cropper" style="text-align:z">
					<vue-cropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
					 :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original"
					 :autoCrop="option.autoCrop" :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
					 :infoTrue="option.infoTrue" :fixedBox="option.fixedBox"></vue-cropper>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<button class="btn" @click="dialogVisible = false " style="background-color: #f2f5f8;">取 消</button>
				<button class="btn subbtn" type="primary" @click="finish" :loading="loading" style="margin-left: 15px;">确认</button>
			</div>
		</el-dialog>
      <el-main>
		<div class="area">
		<div class="box">
                    <p class="return" @click="backa">返回首页</p>
                    <span class="line">|</span>
                    <p class="contract">个人中心</p>          
                </div>
		<div class="headline">个人中心</div>           
		<div class="ibox">
		    
			<div class="table">
				<h4>个人信息</h4>
				
			</div>
			<div class="show basic" v-if="show" style="display:-webkit-inline-box;display:flex;">
				<div class="avatar" :style="imgObj"></div>
				<div class="personCont">
				<div class="dataitems fj2">
						<div class="i_content1">{{baseInfo.name}}</div>
						<div class="i_content2">{{baseInfo.orgName}}</div>
						<div class="i_content3">{{baseInfo.address}}</div>
				</div>
				</div>
				<div class="operating" @click="onshow({editShow})">
					<i class="el-icon-edit-outline">编辑</i>
				</div>				
			</div>
			<div class="edit" v-if="!show">
				<div style="display:-webkit-inline-box;display:flex;margin-left: 30px;">
					<div class="avatar" :style="imgObj"></div>
					<div class="dataitems">
						<el-form :inline="true" ref="baseInfo" :rules="rules" :model="baseInfo" label-position="right" label-width="80px">
							<div class="item">
								<el-form-item label="姓名" prop="name" style="width: 600px">
									<el-input v-model="baseInfo.name"></el-input>
								</el-form-item>
								<el-form-item label="部门" prop="orgName" style="width: 600px">
									<el-input v-model="baseInfo.orgName" disabled></el-input>
								</el-form-item>
								<el-form-item label="所在地" prop="address" style="width: 600px">
									<el-cascader v-model="address" placeholder="请选择" :options="options" filterable></el-cascader>
								</el-form-item>
								<el-form-item label="头像" prop="title" style="width: 600px">
									<!-- element 上传图片按钮 -->
									<el-upload class="upload-demo" action="" drag :auto-upload="false" :show-file-list="false" :on-change="changeUpload">
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">点击上传</div>
										<div class="el-upload__tip">支持绝大多数图片格式，单张图片最大支持500KB</div>
									</el-upload>
								</el-form-item>
							</div>
							<div class="btndiv" v-if="!show">
								<button class="btn" type="button" tag="button" @click="unbase">取消</button>
								<button class="btn subbtn" type="button" @click="upBaseInfo">保存</button>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<div class="ibox">
			<div class="table">
				<h4>账号信息</h4>
			</div>
			<div class="show">
					<div class="i_title">
		             <img  src="../../assets/img/手机.png"></img>
					</div>
					<div class="i_content">
						<span class="num">{{baseInfo.mobile}}</span>
						<span class="greens"><i class="el-icon-check"></i>已认证</span>
					</div>
					<span class="hook"></span>
					<span class="modify" @click="onmodify">修改</span>
				
			
					
				
			</div>
				<div style="margin-top:22px" class="i_title">
		             <img src="../../assets/img/邮箱.png"></img>
						<i v-if="baseInfo.emailStatus == false" class="el-icon-warning"></i>
						<span class="num">{{ baseInfo.email }}</span>
						<span v-if="baseInfo.emailStatus == true" class="greens"><i class="el-icon-check"></i>已认证</span>

					<span class="hook"></span>
					
					<span class="modify" v-if="baseInfo.emailStatus == false" @click="verification">立即验证</span>
					<span class="hook"></span>
					<span class="modify" @click="updateEmail">修改</span>
				</div>
		</div>
		<div class="ibox">
			
			<div class="table">
				<h4>账号安全</h4>
			</div>
			<div class="show">
		             <img  src="../../assets/img/密码.png"></img>
					<div class="num">账号安全<span class="hook"></span>
					<span class="modify"  @click="changePasswd">修改密码</span>
					</div>
				
			</div>
		</div>
		</div>
		</el-main>
	

</div>
	
</template>

<script>
	import {
		chinaData
	} from "../china.js";
	import bgimg from '../../assets/img/avatar.png'
	import {
		VueCropper
	} from 'vue-cropper'

	function isvalidPhone(str) {
		const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
		return reg.test(str)
	}
	var validPhone = (rule, value, callback) => {
		if (!value) {
			callback(new Error('请输入您的新手机号码'))
		} else if (!isvalidPhone(value)) {
			callback(new Error('请输入正确的11位手机号码'))
		} else {
			callback()
		}
	}
	export default {
		name: "SsgPersonSet",
		data() {
			return {
				bindemail:'',
				imgFile:'',
				rules: {
					name: [{
							required: true,
							message: "请输入您的姓名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 10,
							message: "长度在 2 到 10 个字符"
						}
					],
					bindemail:[{
						required: true,
						message: "请输入邮箱",
						trigger: "blur"

					}],
					jobName: [{
							required: true,
							message: "请输入您的职务",
							trigger: "blur"
						},
						{
							min: 2,
							max: 10,
							message: "长度在 2 到 10 个字符"
						}
					]
				},
				show: true,
				maskshow: false,
				masktype: "",
				baseInfo: {},
				baseInfos:{},
				changeInfo: {},
				changerules: {
					password: [{
						required: true,
						message: "请输入您的登录密码",
						trigger: "blur"
					}],
					mobile: [{
						required: true,
						validator: validPhone,
						trigger: "blur"
					}],
					picvert: [{
						required: true,
						message: "请输入图形验证码",
						trigger: "blur"
					}],
					validcode: [{
						required: true,
						message: "请输入手机验证码",
						trigger: "blur"
					}]
				},
				options: chinaData(),
				switchstatus: false, //切换验证码,
				address: [],
				validcodeurl: this.$axios.defaults.baseURL + '/send/imageCode_czsjh',
				count: "", //倒计时
				timer: null, //倒计时状态
				timeshow: false,
				editShow: 1,
				imgObj: '',
				// 裁剪组件的基础配置option
				dialogVisible: false,
				option: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.8, // 裁剪生成图片的质量
					outputType: 'jpeg', // 裁剪生成图片的格式
					canScale: false, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					// autoCropWidth: 300, // 默认生成截图框宽度
					// autoCropHeight: 200, // 默认生成截图框高度
					fixedBox: true, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [5, 5], // 截图框的宽高比例
					full: true, // 是否输出原图比例的截图
					canMoveBox: false, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				picsList: [], //页面显示的数组
				// 防止重复提交
				loading: false
			};
		},
		components: {
			VueCropper
		},
		mounted() {
			this.list = this.$route.query;
		},
		created() {
			this.loadUserInfo();
		},
		methods: {
			unbase(){
				this.show = true
				this.imgObj = {
									'background-image': 'url(' + bgimg + ')',
									'background-size': '120px',
									'background-repeat':'no-repeat',
									'background-position':'center',
								}

			},
			onshow(obj) {
				if (this.baseInfo.address) {
					this.address = this.baseInfo.address.split(',')
				}
			
					this.show = false;
					this.editShow = 0;
			},
			loadUserInfo() {
				this.$axios.get('/person/loadUserPersonData')
					.then(res => {
						if (res.data.status == 1) {
							this.baseInfo = res.data.data
							
							if (res.data.data.portrait) {
								this.imgObj = {
									'background-image': 'url(' + res.data.data.portrait + ')',
									'background-size': '120px',
									'background-repeat':'no-repeat',
									'background-position':'center',
								}
							} else {
								this.imgObj = {
									'background-image': 'url(' + bgimg + ')',
									'background-size': '120px',
									'background-repeat':'no-repeat',
									'background-position':'center',
								}
							}
						} else {
							this.$message.error(res.data.message)
						}
					})
			},
			changePasswd() {
				this.$router.push({
					name: 'changePasswd',
					query: {
						mobile: this.baseInfo.mobile
					}
				})
			},
			upBaseInfo() {
				this.$refs.baseInfo.validate(status => {
					if (status == true) {
						let cityName = ""
						if (this.address.length > 0) {
							cityName = this.address.join(',');
						}						
						let params = new FormData();
                        params.append("name", this.baseInfo.name);
						params.append("address", cityName);
						if(this.fileinfo){
                        params.append("file", this.fileinfo.raw);
						}
						this.$axios.post('/person/updateUserPersonData', params)
							.then(res => {
								if (res.data.status == 1) {
									this.show = true;
									this.$message.success(res.data.message);
									this.loadUserInfo();
									this.$root.$emit('onuser');
								} else {
									this.$message.error(res.data.message)
								}
							})
					}
				});
			},
			subSendEmail(){
                this.maskshow = false;
			    this.masktype = 'veremail';
			},
			verification() {
				this.$axios.post('/person/sendValidEmail')
							.then(res => {
								if (res.data.status == 1) {
									this.maskshow = true;
			                     	this.masktype = 'veremail';
								} else {
									this.$message.error(res.data.message)
								}
							})
				
			},
			onmodify() {
				this.maskshow = true;
				this.masktype = 'replace';
				this.changeInfo.phoneNumber = this.baseInfo.mobile
				this.onswitch()
			},
			sendSms() {
				const params = {
					validcode: this.changeInfo.picvert
				}
				this.$axios.post('/validate/pic_code_valid', params)
					.then(res => {
						if (res.data.status === '0') {
							this.$message.error(res.data.message);
						} else {
							this.realSendSms()
						}
					})
			},
			vsub() {
				this.$refs.changeInfo.validate((valid) => {
					if (valid) {
						this.$axios.post('/person/updateMobile?mobile='+this.changeInfo.mobile+'&mobileValidCode='+this.changeInfo.validcode+'&imageValidCode='+this.changeInfo.picvert+'&password='+this.changeInfo.password)
							.then(res => {
								if (res.data.status == '1') {
									this.$message.success(res.data.message);
									this.maskshow = false;
									this.masktype = '';
									this.logout()
								} else {
									this.$message.error(res.data.message);
								}
							})
					}
				})
			},
			logout() {
				return this.$axios.post('login/logout'		
				).then(res => {
						this.$message.success(res.data.message);
						  this.$router.push({
					          path: '/login',
						  })
				

				}).catch(err => {
					//处理错误
					console.error(err)
					
				})
			},
			onswitch(event) {
				var that = this;
				if (!this.switchstatus) {
					this.switchstatus = true;
					var date = new Date();
				
					// event.currentTarget.previousElementSibling.style.backgroundImage = 'url(' + this.$axios.defaults.baseURL + '/person/getImageValidCode?code=' + date.getTime() + ')'
					this.validcodeurl = this.validcodeurl + '?' + date.getTime();;
					setTimeout(function() {
						that.switchstatus = false
					}, 400);
				}
			},
			realSendSms() {
              
					if (this.changeInfo.mobile && this.changeInfo.mobile.length == 11 ) {
						const params = {
					         mobile: this.changeInfo.mobile,
					        
					   }
					}else {
							this.$message.error('请输入正确的11位新手机号码')
							return
					}
					   
				this.$axios.get('/send/mobelCode_czsjh?mobile='+this.changeInfo.mobile)
					.then(res => {
						if (res.data.status == "0") {
							this.$message.error(res.data.message)
						} else {
							this.$message.success("验证码已经发送到了您的新手机号上");
							this.getCode();
						}
					})
			},
			getCode() {
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.timeshow = true;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							clearInterval(this.timer);
							this.timeshow = false;
							this.timer = null;
						}
					}, 1000)
				}
			},
			// 上传按钮   限制图片大小
			changeUpload(file, fileList) {
				if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
					this.$message.error('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
					return false
				}
				const isLt5 = file.size / 1024 < 500
				if (!isLt5) {
					this.$message.error('上传文件大小不能超过 500KB!')
					return false
				}
				this.fileinfo = file
				// 上传成功后将图片地址赋值给裁剪框显示图片
				this.$nextTick(() => {
					this.option.img = URL.createObjectURL(file.raw);
					this.dialogVisible = true
				})
			},
			backa(){
			 this.$router.push({path: '/main'})
		},
		updateEmail(){ 
			this.maskshow = true
			this.masktype = 'bindemail'
			// this.bindemail = this.baseInfo.email

		},
		subEmail(){
				this.$refs.baseInfos.validate((valid) => {
					if (valid) {
                   this.$axios.post('/person/updateEmail?email='+this.baseInfos.bindemail)
					.then(res => {
						if (res.data.status == 1) {
							 this.maskshow = false
							 this.masktype = 'bindemail'
		                	this.loadUserInfo();		 
							this.$message.success(res.data.message)
						} else {
							this.$message.error(res.data.message);
						}
					})
						}
				})
		},
			finish() {
				this.$refs.cropper.getCropData((data) => {
					this.imgFile = data
					this.imgObj = ''
					this.imgObj = {
								'background-image': 'url(' + data + ')',
								'background-size': '120px',
								'background-repeat':'no-repeat',
								'background-position':'center',
							}
							this.dialogVisible = false

					// var fileName = 'goods' + this.fileinfo.uid
					// this.loading = true
					// let params = {}
					// params.mobile = '18697378518'
					// params.portrait = data
					// this.$axios.post('settings/uploadPortrait', params).then(res => {
					// 	params = {}
					// 	if (res.data.status == 1) {
					// 		this.dialogVisible = false
					// 		this.loading = false
					// 		this.option.img = ''
					// 		this.imgObj = {
					// 			'background-image': 'url(' + res.data.data.portrait + ')',
					// 			'background-size': '104px',
					// 			'background-repeat':'no-repeat',
					// 			'background-position':'center',
					// 		}
					// 		this.$root.$emit('onuser');
					// 	} else if (res.data.status == 0) {
					// 		this.loading = false
					// 	}
					// }).catch(e => console.info(e));
				})
			}

		}
	};
</script>

<style src="../../assets/css/common/form.less" scoped lang="less"></style>
<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/details.less" scoped lang="less"></style>
<style src="../../assets/css/common/additional.less" scoped lang="less"></style>
<style lang="less" scoped>
.el-main{
  height: calc(100vh - 60px);

}
.area{
	// margin-top:80px;
	height:1048px;
}
          .box {
                display: flex;
                margin-top: 20px;

                .return {
                    font-size: 12px;
                    font-weight:400;
                    color:rgba(102,105,227,1);
                    margin-right: 20px;
                    cursor: pointer;
                }

                .line {
                    margin-right: 20px;
                    color: #606266
                }

                .lines {
                    margin-right: 20px;
                    color: #606266;
                    font-weight: bold;
                }

                .contract {
                    margin-right: 20px;

                    font-size: 12px;
                    font-weight:400;
                    color:rgba(138,138,154,1);
                }
            }
  .headline{
	  width:96px;
      height:24px;
      font-size:24px;
      font-weight:bold;
      color:rgba(48,49,64,1);
      line-height:36px;
	  margin:30px 0;
  }
	.ibox:first-child {
		border-top: 0;
	}

	.edit {
		padding-top: 30px !important;
	}
	.ibox .edit[data-v-32719c61] {
    width: 100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.11);
    border-radius:6px;
    border:1px solid rgba(255,255,255,1);
    padding-top: 50px;
    margin-bottom: 30px;
	border-top:4px solid #6669E3;
}

	.el-form-item {
		margin-bottom: 15px;
	}

	.avatar {
		width: 120px;
		height: 119px;
		border-radius: 50%;
		border: 2px solid #e4e6ec;
		background-size: 100%;
		background-repeat: no-repeat;
		background-position: center;
		margin: 56px 51px 60px 51px;

	}
	.personCont{
		display:flex;
		
	}

	.dataitems {
		width: 500px;
		margin-top:66px;
		.i_content1{
			font-size:18px;
            font-weight:bold;
            color:rgba(48,49,64,1);
		}
		.i_content2{
			font-size:14px;
           font-weight:bold;
           color:rgba(48,49,64,1);
		}
		.i_content3{
			font-size:12px;
           font-weight:400;
           color:rgba(48,49,64,1);
		}
		div {
			margin-bottom:16px;  
		}
	}

	.hook {
		display: inline-block;
		margin-right: 20px;
	
	}
	.prompt {
		line-height: 30px;
		font-size: 12px;
		margin: 20px 0;


		a {
			color: #6669e3;
		}

		span {
			color: #fd6652;
		}
	}
	.tent{
		display: flex;
		justify-content: space-between;
			margin: 20px 0 ;
		
		img{
			width: 50px;
			height: 50px;
			margin-right: 20px;
		}
	}

	.pad10 {
		padding-left: 10px;
	}

	.form {
		padding: 10px;
		box-sizing: border-box;
	}

	.mobilecert {
		position: absolute;
		right: -120px;
		top: 4px;
		height: 30px;
		display: flex;
		align-items: center;
	}

	.nosmsbtn {
		position: absolute;
		right: -120px;
		top: 4px;
		border: 1px solid #cdcdcd;
		height: 30px;
		padding: 0 13px;
		border-radius: 6px;
		min-width: 84px;
		color: #636363;
		font-size: 14px;
		background-color: #f2f2f5;
		cursor: pointer;
		float: right;
	}

	.basic {
		width:1169px;
        height:235px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.11);
        border-radius:6px;
        border:1px solid rgba(255,255,255,1);
		border-top:4px solid #6669E3;
		position:relative;
	}

	.cropper-content {
		.cropper {
			width: auto;
			height: 300px;
		}
	}
	.modify{
		font-size:12px;
       font-weight:400;
       color:rgba(102,105,227,1);
	   cursor:pointer
	}
	.num{
		font-size:12px;
font-weight:400;
color:rgba(48,49,64,1);
margin-left:5px;
	}
.qqIcom{
	display:block;
}
	.operating {
		cursor: pointer;
		position:absolute;
		right:50px;
		bottom:0;
		margin:100px auto;
		width:64px;
        height:32px;
        border-radius:4px;
        border:1px solid rgba(102,105,227,1);
		color:#6669E3;
		line-height: 32px;
         text-align: center;
		
	}
	
	.fj2{
		.item{
			width: 100% !important;
		}
	}
	
	.el-icon-upload{
		margin: 16px 0 !important;
	}
	
	.el-dialog__wrapper /deep/ .el-dialog__header{
		padding: 20px 20px;
		border-bottom: 1px solid #e9eff4;
	}
	
	.el-dialog__wrapper /deep/ .el-dialog__title{
		font-weight: bold;
	}
	
	.el-dialog__wrapper /deep/ .el-dialog__footer{
		background-color: #f2f5f8;
	}
	
	.edit /deep/ .el-upload-dragger:hover {
		border-color: #6669e3;
	}
	.greens{
     background-color: #3bc798;
    color: #fff;
    display: initial;
    align-items: center;
    padding: 0 5px;
    border-radius: 2px;
    margin-left: 9px;
    i {
        margin-right: 3px;
        font-weight: bolder;
    }
}
</style>
